import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import Link from 'next/link';
import { getDoc, doc } from 'firebase/firestore/lite';
import { getUserName } from '../../services/common-query';
import { bucketlink1 } from '../../config/fire-conf';
import { firebaseFireStore } from '../../config/firebaseFirestore';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

export default function HistoryComponent(props) {
  const bsvRate = useSelector((state) => state.bsvRateReducer.bsvRate);

  const { ele, nftData } = props;
  const [isSellerMentor, setisSellerMentor] = useState(false);
  const [ownerName, setownerName] = useState(false);

  useEffect(() => {
    if (props.ele && props.ele.userId) {
      isUserMinterFunc();
      getNameFromId();
    }
  }, [props.ele.userId]);

  const isUserMinterFunc = async () => {
    let dbRef = await getDoc(
      doc(firebaseFireStore, 'musicartMinters', props.ele.userId),
    );

    if (dbRef.data()) {
      setisSellerMentor(true);
    }
  };

  const getNameFromId = async () => {
    let lname = await getUserName(props.ele.userId);

    if (lname) {
      setownerName(lname);
    } else {
      setownerName('unknown');
    }
  };

  const nftQuan = nftData.nftQuantity ? parseInt(nftData.nftQuantity) : 1;
  const nftIndex =
    nftData.multipleNftDetails &&
    ele.nftId &&
    nftData.multipleNftDetails[ele.nftId]?.index
      ? nftData.multipleNftDetails[ele.nftId].index
      : 1;

  return (
    <div className="asset__action" key={props.ele.id}>
      <div>
        <div
          className={
            isSellerMentor
              ? 'asset__action asset__action--verified'
              : 'asset__action'
          }
        >
          <img
            style={{ minWidth: 44, minHeight: 44 }}
            src={
              bucketlink1 +
              'profile_images%2F' +
              props.ele.userId +
              '_250x250?alt=media'
            }
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = '/img/avatars/avatar.jpg';
            }}
            alt="profile-image"
          />
        </div>
      </div>
      <div className="w-10/12">
        <p>
          {`No ${nftIndex}/${nftQuan} `}
          {(() => {
            if (props.ele.type === 'MINT') {
              return 'NFT minted';
            } else if (props.ele.type === 'PURCHASE') {
              return `Purchased for $${props.ele.bidPrice}`;
            } else if (props.ele.type === 'AUCTIONEND' && bsvRate) {
              return `Auction won at $${(props.ele.bidPrice * bsvRate).toFixed(
                2,
              )}`;
            }
          })()}
          {/* <b>{props.ele.bidPrice}  </b>,{" "} */}{' '}
          {moment(props.ele.timestamp).fromNow(true) + ' '}
          ago
          <br />
          {props.ele.userId ? (
            <>
              by{' '}
              <Link prefetch={false} href={'/collector/' + props.ele.userId}>
                <a>{ownerName && `@${ownerName}`}</a>
              </Link>
              {props.ele.txid ? (
                <OpenInNewIcon
                  style={{
                    width: 15,
                    height: 15,
                    marginLeft: 4,
                  }}
                  className="link"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    window.open(
                      `https://whatsonchain.com/tx/${props.ele.txid}`,
                    );
                  }}
                />
              ) : (
                ''
              )}
            </>
          ) : (
            'by unknown'
          )}
        </p>
      </div>
    </div>
  );
}
